<template>

    <div class="chart-dog-preview">

        <tool-output-page :page-number="1"
                          :page-count="exportSummary.pageTotal">

            <!-- the chart -->
            <highcharts :options="chartConfig" :callback="chartTest"></highcharts>

            <div v-if="docData.showCommentsInReport && docData.comments != ''">
                <h2>Comments</h2>
                <!-- NB: don't indent here -->
                <div class="report-comments">
                    {{ docData.comments }}
                </div>
            </div>

        </tool-output-page>

        <!-- data -->

        <tool-output-page :page-number="2"
                          :page-count="exportSummary.pageTotal">

            <h2>Data Points</h2>
            <table class="table table-striped">
                <thead>
                <tr>
                    <th>Date</th>
                    <th v-for="(series, index) in docData.chart.chartSeries">
                        {{ series.title ? series.title : 'Series ' + (index + 1) }}
                    </th>
                </tr>
                </thead>
                <tbody v-for="pdt in exportSummary.phaseDataTables">
                <tr>
                    <td :colspan="docData.chart.chartSeries.length + 1"
                        :class="`phase-${pdt.phase.index}`">
                        {{ pdt.phase.title }}
                    </td>
                </tr>
                <tr v-for="row in pdt.phaseRows">
                    <td>{{ row.date | moment("MMM D, YYYY") }}</td>
                    <td v-for="val in row.seriesValues">
                        {{ val }}
                    </td>
                </tr>
                </tbody>
            </table>
        </tool-output-page>

        <tool-output-page :page-number="exportSummary.trendPageNumber"
                          :page-count="exportSummary.pageTotal">

            <h3>Trendline Analysis</h3>

            <table class="table table-striped">
                <thead>
                <tr>
                    <th v-for="series in docData.chart.chartSeries"
                        v-if="series.showTrendline">
                        {{ series.title ? series.title : 'Series ' + ($index + 1) }}
                    </th>
                </tr>
                </thead>
                <tbody v-for="phase in docData.chart.phases">
                <tr>
                    <td :colspan="docData.chart.chartSeries.length"
                        :class="`phase-${phase.index}`">
                        {{ phase.title }}
                    </td>
                </tr>
                <tr>
                    <td class="data-analysis"
                        v-for="series in docData.chart.chartSeries"
                        v-if="series.showTrendline">

                        <div ng-init="pointCount = ">
                            <div v-if="listDataPointsForSeriesAndPhase(series.index, phase.index).length == 0">
                                <p class="no-data">No data points</p>
                            </div>

                            <div v-else>
                                <p>
                                    ({{ listDataPointValuesForSeriesAndPhase(series.index, phase.index) }})
                                </p>
                                <p>
                                <div class="analysis-description">
                                    {{ getTrendlineDescription(series, phase).body }}
                                    <br/>
                                    <em class="analysis-notes">{{ getTrendlineDescription(series, phase).notes }}</em>
                                </div>
                                </p>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </tool-output-page>

        <tool-output-page v-if="exportSummary.meanPageNumber"
                          :page-number="exportSummary.meanPageNumber"
                          :page-count="exportSummary.pageTotal">

            <h3>Mean Values</h3>

            <table class="table table-striped">
                <thead>
                <tr>
                    <th v-for="(series, index) in docData.chart.chartSeries"
                        v-if="series.showMean">
                        {{ series.title ? series.title : 'Series ' + (index + 1) }}
                    </th>
                </tr>
                </thead>
                <tbody v-for="phase in docData.chart.phases">
                <tr>
                    <td :colspan="docData.chart.chartSeries.length"
                        :class="`phase-${phase.index}`">
                        {{ phase.title }}
                    </td>
                </tr>
                <tr>
                    <td class="data-analysis"
                        v-for="series in docData.chart.chartSeries"
                        v-if="series.showMean">

                        <div v-if="listDataPointsForSeriesAndPhase(series.index, phase.index).length == 0">
                            <p class="no-data">No data points</p>
                        </div>

                        <div v-else>
                            <p>
                                ({{ listDataPointValuesForSeriesAndPhase(series.index, phase.index) }})
                            </p>
                            <p>
                            <div class="analysis-description">
                                {{ getMeanDescription(series, phase).body }}
                            </div>
                            </p>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </tool-output-page>

    </div>

</template>

<script>

    import Vue from 'vue'
    import ToolMixin from '@/providers/ToolMixin'
    import ChartDogMixin from "@/providers/ChartDogMixin"

    export default Vue.extend({
        name: "ChartDogPreview",
        mixins: [ToolMixin, ChartDogMixin],
    })

</script>


